import { render, staticRenderFns } from "./LowPricedProductsLinks.vue?vue&type=template&id=7cc6261a"
import script from "./LowPricedProductsLinks.vue?vue&type=script&lang=js"
export * from "./LowPricedProductsLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports